import React from 'react';

interface ILoadingProps {
  fixed?: boolean;
  className?: string;
  dataTestId?: string;
}

const Loading = ({ fixed, className, dataTestId }: ILoadingProps) => (
  <div
    className={`${
      fixed && 'loadingFixed'
    } ${className} d-flex justify-content-center align-items-center h-100`}
  >
    <div className="spinner-border text-blue-light" role="status">
      <span className="sr-only" data-test={dataTestId}></span>
    </div>
  </div>
);

export default Loading;
